import React from 'react'
import PropTypes from 'prop-types'
import NavLink from 'components/header/nav-link'

const NavTab = ({ permissions = [] }) => (
  <div>
    <div className='portlet-body'>
      <ul className='nav nav-tabs'>
        {permissions.includes('MANAGE_USERS')
          ? [
            <NavLink key='1' to='/admin/users'>
              Users
            </NavLink>,
            <NavLink key='2' to='/admin/permissions/user'>
              User Permissions
            </NavLink>
          ]
          : null}

        {permissions.includes('MANAGE_TENANTS')
          ? [
            <NavLink key='1' to='/admin/tenants'>
                Tenants
              </NavLink>,
            <NavLink key='2' to='/admin/permissions/tenant'>
                Tenant Permissions
              </NavLink>
          ]
          : null}
      </ul>
    </div>
  </div>
)

NavTab.displayName = 'NavTab'

NavTab.propTypes = {
  permissions: PropTypes.array
}

export default NavTab



// WEBPACK FOOTER //
// ./src/pages/admin/nav-tab.js